import { getRecreateProductInfo } from "./recreateProductInfo"
import { parseStoryboardPayload, validateStoryboardContent } from "./storyboard"
import { RECREATE_IMAGE_LIMIT } from "./recreate"

export const buildFusionDraft = (task: API.Staff.ScriptFusionPreview) => {
  const parse = task.parse_video
  const optimize = task.optimize_prompt
  if (!parse?.video_url?.trim() || !optimize?.result_prompt?.trim())
    throw new Error("融合预览缺少参考视频或视频脚本，请重新融合后重试")
  if (
    typeof parse.result_text !== "string" ||
    typeof parse.audio_url !== "string" ||
    typeof parse.wallet_execution_id !== "string" ||
    !optimize.product_info ||
    !Number.isFinite(optimize.duration) ||
    optimize.duration <= 0
  )
    throw new Error("融合预览的解析或商品信息不完整")
  const images = optimize.image_urls
  if (
    !Array.isArray(images) ||
    !images.length ||
    images.some((url) => typeof url !== "string" || !url.trim())
  )
    throw new Error("融合预览缺少有效参考图片")
  if (images.length > RECREATE_IMAGE_LIMIT)
    throw new Error(
      `融合记录包含 ${images.length} 张参考图，当前最多支持 ${RECREATE_IMAGE_LIMIT} 张，请在来源页面调整后重试`,
    )
  if (new Set(images.map((url) => url.trim())).size !== images.length)
    throw new Error("融合预览包含重复参考图，请调整后重试，避免图片编号错位")
  const payload = parseStoryboardPayload(optimize.result_prompt)
  if (payload) {
    const { errorMessage } = validateStoryboardContent(payload.rows)
    if (errorMessage) throw new Error(errorMessage)
  }
  for (const match of optimize.result_prompt.matchAll(/@图片\s*(\d+)/g)) {
    if (Number(match[1]) < 1 || Number(match[1]) > images.length)
      throw new Error("融合脚本引用了不存在的参考图片，请重新融合")
  }
  return {
    preview: {
      parse_video: parse,
      optimize_prompt: optimize,
      frontend_remark: task.frontend_remark,
    } satisfies API.Staff.HotVideoTaskInput,
    videoUrl: parse.video_url,
    videoImageUrls: images.join("\n"),
    productInfo: getRecreateProductInfo(optimize.product_info),
    sourcePrompt: parse.result_text,
    replicaPrompt: optimize.result_prompt,
    duration: optimize.duration,
  }
}
